import React from "react";
import DocumentAchatEntity from "./DocumentAchatEntity";

const FactureAchat = () => {
    return <DocumentAchatEntity type="Facture Achat" title="Factures Achat" endpoint="FactureAchat" />;
};

export default FactureAchat;
